import React from 'react';
import { Store } from 'react-notifications-component';
import { handleNullException } from '../../services/UtilsService';
import ErrorFlag from './ErrorFlag';
import SuccessFlag from './SuccessFlag';
import WarningFlag from './WarningFlag';

const defaultErrorMessage = 'Unfortunately, it fails pls try again later';
const defaultSuccessMessage = 'Success';
export const addToastForAPIResponse = (type: 'success' | 'error' | 'warning' | undefined, message?: string) => {
  Store.addNotification({
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: type?.toLowerCase() === 'error' ? 8000 : 3000,
    },
    content:
      //  eslint-disable-next-line
      type?.toLowerCase() === 'error' ? (
        <ErrorFlag title={message || defaultErrorMessage} />
      ) : type?.toLowerCase() === 'warning' ? (
        <WarningFlag title={message || defaultSuccessMessage} />
      ) : (
        <SuccessFlag title={message || defaultSuccessMessage} />
      ),
  });
};

//  eslint-disable-next-line
export const apiErrorToast = (error: any) => {
  const message =
    handleNullException(error, 'response.data.message') || handleNullException(error, 'response.data.error');
  if (message) {
    addToastForAPIResponse('error', message.toString());
    return;
  }
  addToastForAPIResponse('error');
};
